var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAdyen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 21,
    viewBox: "0 0 65 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.025 4.802v7.939c0 .32.251.64.629.64h1.258v-8.58h4.72v13.894c0 1.28-1.007 2.305-2.265 2.305h-8.873v-3.33h6.418v-1.408H28.57c-1.258 0-2.265-1.024-2.265-2.305V4.802h4.72zm-22.026 0c1.259 0 2.266 1.024 2.266 2.305v9.155h-9C1.007 16.262 0 15.238 0 13.957v-2.56C0 10.115 1.007 9.09 2.265 9.09H4.72v3.65c0 .32.251.64.63.64h1.258V8.323c0-.32-.252-.64-.63-.64H.188V4.802zM24.417 0v16.262h-9c-1.258 0-2.265-1.024-2.265-2.305v-6.85c0-1.28 1.007-2.305 2.266-2.305h2.454v7.939c0 .32.252.64.63.64h1.258L19.697 0h4.72zm24.102 4.802c1.259 0 2.266 1.024 2.266 2.305v2.56c0 1.281-1.007 2.306-2.266 2.306h-2.454v-3.65c0-.32-.252-.64-.63-.64h-1.258v5.058c0 .32.252.64.63.64h5.789v2.881h-8.873c-1.259 0-2.266-1.024-2.266-2.305V4.802zm13.153 0c1.258 0 2.265 1.024 2.328 2.305v9.155h-4.72V8.323c0-.32-.251-.64-.63-.64h-1.258v8.58h-4.72V4.801z",
    transform: "translate(-924.000000, -451.000000) translate(290.000000, 203.000000) translate(313.000000, 206.000000) translate(84.000000, 40.000000) translate(237.904762, 2.000000)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAdyen);
export default __webpack_public_path__ + "static/media/logo-adyen.8670a9e6.svg";
export { ForwardRef as ReactComponent };